export enum VehicleType {
  ADAPTER_VEHICLE = 'ADAPTER_VEHICLE',
  CONNECT_VEHICLE = 'CONNECT_VEHICLE',
  HYBRID_VEHICLE = 'HYBRID_VEHICLE',
  NONE = 'NONE',
}
